import { userApiRequest } from "./client";
import { useQuery } from "react-query";
const _30_MINS = 1e3 * 30 * 60;
function fetchEducator(userId) {
  return userApiRequest({
    url: `/user/educator/${userId}/public`,
    method: "GET"
  }).catch(() => {
    return {};
  });
}
function useEducatorQuery(userId) {
  return useQuery(["user", userId], () => fetchEducator(userId), {
    staleTime: _30_MINS,
    enabled: !!userId
  });
}
export {
  fetchEducator,
  useEducatorQuery
};
